import core from '@/helpers/client'
const warehouseService = {
  async headWarehouseAsync(params) {
    const result = await core.head(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/warehouses`,
      params
    )
    return result
  },
  async getWarehouseListAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/warehouses`,
      params
    )
    return result
  },
  async getWarehouseDetailAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/warehouses/${id}`
    )
    return result
  },
  async createWarehouseAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/warehouses`,
      model
    )
    return result
  },
  async updateWarehouseAsync(id, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/warehouses/${id}`,
      model
    )
    return result
  },
  async deleteWarehouseByIdAsync(id) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/warehouses/delete/${id}`
    )
    return result
  },
}
export default warehouseService
